import { api } from "@/api";
import { ThreadOptionsResponse, threadStore } from "@/store/thread";
import useSWR from "swr";

export function useLatestThreadOptions(threadId: string) {
  const shouldFetch = Boolean(threadId) && !threadStore.isThreadHangUp;

  useSWR<ThreadOptionsResponse>(
    shouldFetch ? ["thread-options", threadId] : null,
    async (key) => {
      const res = await api.request<ThreadOptionsResponse>({
        path: `/api/v1/threads/${key[1] as string}/options`,
        method: "GET",
      });
      return res.data;
    },
    {
      refreshInterval: shouldFetch ? 5000 : 0,
      onSuccess: (data) => {
        if (data) {
          threadStore.setThreadOptions(data);
        }
      },
      onError: (error) => {
        console.error("Failed to fetch thread options:", error);
      },
    }
  );

  return {
    threadOptions: threadStore.threadOptions,
  };
}
